var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wait-points-animation"},[_vm._t("default"),_c('span',{staticClass:"points"},[_vm._v("...")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }